import React, { FC, ReactNode } from "react";
import { Trans, t } from "@helpers/translate";

const Icon = () => {
  const strokeWidth = 1.4;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      className="w-8 h-8"
    >
      <title id="GWGLogoTitle">
        {t({
          id: "common.svg.title",
          message: `GoWithGuide`,
        })}
      </title>
      <desc id="GWGLogoDesc">
        <Trans id="common.svg.description">
          Find your perfect tour guide at GoWithGuide. Relax and cherish
          unforgettable tours with loved ones. Create personalized tours for a
          truly memorable trip!
        </Trans>
      </desc>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
};
//use svg icon as a fallback if no image found for that city or coutry
type ItemProps = {
  children: ReactNode;
  imageUrl?: string;
};

export const Item: FC<ItemProps> = ({ children, imageUrl }) => {
  return (
    <div className="hover:bg-gray-50 cursor-pointer flex items-center border-b border-gray-100 hover:border-transparent px-4 py-2">
      <div className="mr-4">
        <div className="w-14 h-14 border rounded-full bg-white flex items-center justify-center overflow-hidden">
          {imageUrl ? (
            <img src={imageUrl} alt="" className="w-full h-full object-cover" />
          ) : (
            <Icon />
          )}
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
};
